import { render, staticRenderFns } from "./TaskSidebar.vue?vue&type=template&id=578cc74b&scoped=true"
import script from "./TaskSidebar.vue?vue&type=script&lang=js"
export * from "./TaskSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578cc74b",
  null
  
)

export default component.exports